//////////////////////////////////////////////////////////////////////
//
//  10/11/18
//  src/components/IconRowHelp.js
//
//  This file lists all the 'inline' styles to help with the Icon Row display data.
//
//  Note: I am using this method because I am using individual 'id's for each button
//  thus, I need to use inline style because I don't know what exactly the 'id' will be.
//

export const IRH_myModal = { 
/*****************************************************/
/*                                                   */
/* This is all for the fade-in pop-up area.          */
/*                                                   */
/* Note: We initially used 'display: none' and 
   'display: block' but you cannot 'transition'
   a display, so I changed it to 'opacity' and 
   'visibility' (look at the javascript).
*/
  opacity    : "0",
  visibility : "hidden",
  position   : "fixed",     /* Stay in place      */
  zIndex     : "1",         /* Sit on top         */
  left       : "0",
  top        : "0",
  width      : "100%",      /* Full width         */
  height     : "100%",      /* Full height        */
  overflow   : "auto",      /* Enable scroll if needed  */
/*backgroundColor: "rgb( 0, 0, 0 )",       -- Fallback color   */
  backgroundColor: "rgba( 0, 0, 0, 0.6 )", /* Black w/ opacity */
  paddingBottom : "55px",
};
/*** This was all moved to 'IconRow.js'...
export const IRH_myImg = {
  backgroundColor : "rgba( 0, 0, 0, 0.6 )",
  paddingTop : "20px",
  zIndex    : "5"
};

export const IRH_close = {
  position      : "relative",
  marginRight   : "10px",
  marginTop     : "-15px",
  paddingLeft   : "40px",
  paddingBottom : "10px",
  paddingRight  : "10px",
  color         : "white",
  float         : "right",
  fontSize      : "4.0em",
  fontWeight    : "bold",
  zIndex        : "10",
  cursor        : "pointer",
}
***/



// WEBPACK FOOTER //
// ./src/components/IconRowHelp.js